import { render, staticRenderFns } from "./CreateProposedLogisticsLeadTime.vue?vue&type=template&id=3833a37e&scoped=true&"
import script from "./CreateProposedLogisticsLeadTime.vue?vue&type=script&lang=js&"
export * from "./CreateProposedLogisticsLeadTime.vue?vue&type=script&lang=js&"
import style0 from "./CreateProposedLogisticsLeadTime.vue?vue&type=style&index=0&id=3833a37e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833a37e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCol,VContainer,VForm,VRow})
